import { render, staticRenderFns } from "./couponstable.vue?vue&type=template&id=70e73524&scoped=true"
import script from "./couponstable.vue?vue&type=script&lang=js"
export * from "./couponstable.vue?vue&type=script&lang=js"
import style0 from "./couponstable.vue?vue&type=style&index=0&id=70e73524&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e73524",
  null
  
)

export default component.exports